import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {WidgetData} from "../../../../../../../../core/shared/widget/widget-data";
import {FilterCriteria} from "../../../../../../../../core/shared/filter/api/filter.criteria";
import {WidgetFactory} from "../../../../../../../../core/shared/widget/service/widget.factory";
import {
    WidgetFunctionCallBackCreate,
    WidgetToolbarCreateInterface
} from "../../../../../../../../core/shared/helper/widget-function-call-back-create";


@Component({
    selector: 'bm-creditor-bank-account-details',
    templateUrl: 'creditor-bank-account-details.component.html',
    standalone: false
})
export class CreditorBankAccountDetailsComponent implements OnInit, OnChanges, OnDestroy {

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    @Input() creditorId: number;

    creditorBankAccountDetailsWidgetData: WidgetData

    constructor() {
    }

    ngOnInit(): void {
        this.initComponent();

    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {

        const filterCriteria = FilterCriteria.create('e.creditorId', FilterCriteria.cOperatorEqual, this.creditorId);

        this.creditorBankAccountDetailsWidgetData = WidgetFactory.createWidgetTableEntityBasicQl('bm.creditor.bank.account.details.widget.data.new', 'Creditor Bank Account Details', 'bm.CreditorBankAccount', [filterCriteria]);

        const fields: WidgetToolbarCreateInterface[] = [{
            fieldName: 'creditorDtoId',
            fieldValue: this.creditorId
        }];
        this.creditorBankAccountDetailsWidgetData.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);

        this.initialized = true;
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
